import { Entity } from '../entity';

export enum AddressType {
    /** @deprecated use Standard */
    Lookup = 'Lookup',
    Standard = 'Standard',
    Coordinates = 'Coordinates',
    What3Words = 'What3Words'
}

/** Engine powering the address-search box on the manual address form.
 *  AddressValidation = the address validation/standardisation service (driven by an AddressValidation service
 *  connection); Place = Google Place search (the default fallback); None = no search box. */
export enum AddressLookupProvider {
    AddressValidation = 'address-validation',
    Place = 'place',
    None = 'none'
}

export interface Address extends Entity {
    // fullAddress?: string,
    street1?: string;
    street2?: string;
    suburb?: string;
    county?: string;
    state?: string;
    postcode?: number;
    postalCode?: string;
    country?: string;
    lat?: number;
    lgn?: number;
    timezone?: string;
    matchKey?: string;
    type?: AddressType;
    //This property is not saved to the address, but instead used by
    //other entities that want a friendly name for the address
    //At this stage, only the address validation will set this property
    //friendlyName?: string;
}

export interface ValidatedAddress extends Address {
    validationResult?: any;
}

export interface StructuredAddress {
    state: string;
    postcode: string;
    localityName: string;
    streetName: string;
    streetType: string;
    streetSuffix: string;
    streetNumber1: string;
    streetNumberSuffix1: string;
    flatNumber: string;
    lotNumber: string;
    postalType: string;
    addressId: string;
    houseNo1: string;
    houseSuffix1: string;
    houseNo2: string;
    houseSuffix2: string;
    flatType: string;
    flatNo: string;
    levelType: string;
    levelNo: string;
    buildingName1: string;
    buildingName2: string;
    lotNo: string;
    postalNo: string;
    postalPrefix: string;
    postalSuffix: string;
    flag: string;
    flagString: string;
    preAddress1: string;
    preAddress2: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    postAddress: string;
    amendedFlag: string;
    latitude: string;
    longitude: string;
    reliability: string;
    MB: string;
    CD: string;
    SLA: string;
    gifFields: GifFields;
}


export interface StandarizeAddress {
    state: string;
    postCode: string;
    locality: string;
    streetName: string;
    streetType: string;
    houseNo1: string;
    houseSuffix1: string;
    houseNo2: string;
    houseSuffix2: string;
    flatType: string;
    flatNo: string;
    flatNumber: string;
    address1: string;
    address2: string;
    address3: string;
    latitude: string;
    longitude: string;

    //Lat
    gifField1: string;
    //Lgn
    gifField2: string;
}

export interface GifFields {
    'LatLong.Latitude': string;
    'LatLong.Longitude': string;
    'LatLong.Reliability': string;
    'LatLong.Latitude.flag': string;
    'LatLong.Longitude.flag': string;
    'LatLong.Reliability.flag': string;
}

export const AustraliaTimezones = {
    NSW: 'Australia/Sydney',     // New South Wales
    VIC: 'Australia/Melbourne',  // Victoria
    QLD: 'Australia/Brisbane',   // Queensland
    TAS: 'Australia/Hobart',     // Tasmania
    SA: 'Australia/Adelaide',    // South Australia
    WA: 'Australia/Perth',       // Western Australia
    NT: 'Australia/Darwin',      // Northern Territory
    ACT: 'Australia/Canberra',   // Australian Capital Territory (same as NSW, but there's no separate IANA timezone)
};

/** Resolve an IANA timezone from an Australian state abbreviation. Case-insensitive to tolerate
 *  upstream casing (Intech grammar / Google geocode). Broken Hill (NSW) observes Central time, not
 *  Eastern, so it is handled as a suburb exception. Returns null for missing/unknown states. */
export function getAustralianTimezone(state?: string, suburb?: string): string | null {

    if (!state) return null;

    const isBrokenHill = state.toLowerCase() === 'nsw' && suburb?.toLowerCase() === 'broken hill';

    return isBrokenHill
        ? 'Australia/Broken_Hill'
        : AustraliaTimezones[state.toUpperCase() as keyof typeof AustraliaTimezones] ?? null;
}